<template>
  <div class="mb-0 mb-md-5">
    <div class="header-content">
      <div class="d-flex justify-content-between align-items-center">
        <router-link tag="a" to="/web/homepage" class="">
          <img :src="require('../assets/images/logo.png')" alt="" height="48px">
        </router-link>
        <div class="d-flex align-items-center">
          <b-dropdown  no-caret>
            <template #button-content>
              <span>{{ $t($i18n.locale) }}</span>
              <span class="ml-2"><i class="fa fa-chevron-down"></i></span>
            </template>

            <b-dropdown-item
              v-for="item in $i18n.availableLocales"
              :key="item"
              @click="changeLanguage(item)"
            >
              {{ $t(item) }}
            </b-dropdown-item>
          </b-dropdown>

          <div v-if="!$route.path.includes('register')" id="tooltip-button-1"
            class="text-20 ml-4 text-primary position-relative" tabindex="0">
            <img src="../assets/images/action/notification-header.png">
            <span v-if="this.$root.unRead > 0" class="notification-badge text-14">{{ this.$root.unRead }}</span>
          </div>

          <b-popover target="tooltip-button-1" triggers="click blur" placement="bottom" container="body"
            boundary="window" custom-class="news-popover">
            <div class="font-weight-700 text-14 mb-3 mt-2">{{ $t('recently_receive') }}</div>
            <div v-if="$root.newsList && $root.newsList.length">
              <div v-for="item in $root.newsList.slice(0, 4)" :key="item.id" @click="openNews(item)"
                class="d-flex align-items-start my-2">
                <img :src="item.public_path" height="56" width="56" class="news-img" />
                <div class="ml-2">
                  <div v-html="item.title.replace(/(\r\n|\r|\n)/g, '<br>')" class="text-12 font-weight-600 mb-1"></div>
                  <div v-html="item.description.replace(/(\r\n|\r|\n)/g, '<br>')" class="text-gray text-12 mb-1"></div>
                </div>
                <div v-if="item.is_read == 0" class="ml-auto">
                  <b-icon icon="dot" class="text-danger text-24"></b-icon>
                </div>
              </div>
            </div>

            <div v-if="$root.newsList.length > 4" class="py-2 text-center text-primary" @click="openMore">
              {{ $t('more') }}
            </div>
          </b-popover>

        </div>
      </div>
    </div>
    <b-modal id="modal-notification" hide-footer centered>
      <div class="">
        <img :src="$root.newsItem.public_path" alt="" height="auto" width="100%" class="rounded-1">
        <div class="text-left mt-3">
          <div class="text-18 text-primary font-weight-600 mb-2">{{ $root.newsItem.title }}</div>
          <div class="text-secondary text-12 mb-3">{{ $root.newsItem.updated_at }}</div>
          <div class="mb-1 text-16" v-html="$root.newsItem.description.replace(/(\r\n|\r|\n)/g, '<br>')"></div>
        </div>
      </div>

    </b-modal>
  </div>
</template>
<script>
import { readNews } from "@/system/request/api/api";
import { handleError } from "@/system/request/handleRes";
export default {
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lan', lang);
    },
    openNews(item) {
  if (item.is_read === 0) {
    let formData = new FormData();
    formData.append("news_id", item.id);

    this.$root.isLoading = true;

    readNews(formData)
      .then((value) => {
        if (String(value.data.error_code) === "0") {
          this.$root.newsItem = item;

          // 等待 getNewsList 完成
          Promise.resolve(this.$root.getNewsList())
            .then(() => {
              this.$bvModal.show('modal-notification');
              this.$root.isLoading = false;
            })
            .catch(err => {
              console.error('getNewsList error:', err);
              this.$root.isLoading = false;
              this.$bvModal.show('modal-notification');
            });

        } else {
          this.$root.makeToast("danger", this.$t(value.data.message), 'danger');
          this.$root.isLoading = false;
        }
      })
      .catch((error) => {
        console.log(error);
        this.$root.makeToast("warning", this.$t(handleError(error)), 'danger');
        this.$root.isLoading = false;
      });
  } else {
    this.$root.newsItem = item;
    this.$bvModal.show('modal-notification');
  }
},
    openMore() {
      if (this.isNewsRoute) return;

      this.show = false;
      this.$router.push('/web/news');
    }
  },
  created() {
    const token = localStorage.getItem("currencyToken");
    if (token) {
      this.$root.getNewsList();
    }
  }

}
</script>

<style scoped></style>